import { CustomSearchXStoreModule } from '../types';

// eslint-disable-next-line max-len
export const clearSingleShopSearchBox: CustomSearchXStoreModule['actions']['clearSingleShopSearchBox'] =
  ({ commit }) => {
    commit('setSingleShopQuery', '');
    commit('setSingleShopResults', []);
    commit('setIsSingleShopNoResults', false);
  };
